<template>
  <v-container>
    <v-layout wrap class="mb-4">
      <v-form
        ref="eventForm"
        v-model="valid"
        class="width-100"
        v-if="!eventCreated"
      >
        <v-flex>
          <h3 class="mb-3">New Event</h3>
        </v-flex>
        <v-flex xs12>
          <v-select
            label="Partner*"
            v-model="editObject.dsec_partner_id"
            :items="partners"
            item-text="name"
            item-value="id"
            required
            :rules="rules.required"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-select
            label="Program"
            v-if="
              editObject.dsec_partner_id &&
              filteredPrograms &&
              filteredPrograms.length
            "
            v-model="editObject.dsec_program_id"
            :items="filteredPrograms"
            item-text="name"
            item-value="id"
          ></v-select>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Event/Activity Name*"
            v-model="editObject.name"
            required
            :rules="rules.required"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 class="mt-4">
          <v-textarea
            label="Description (please limit to 200 characters or less)*"
            v-model="editObject.description"
            rows="3"
            :rules="rules.description"
          >
          </v-textarea>
        </v-flex>
        <v-flex xs12 class="mt-4">
          <v-radio-group
            v-model="editObject.dsec_funded"
            mandatory
            :rules="rules.bool"
          >
            <template v-slot:label>
              <div>Is the event/activity funded by DSEC?*</div>
            </template>
            <v-radio :value="true">
              <template v-slot:label>
                <div>Yes</div>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template v-slot:label>
                <div>No</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 class="mt-4" v-if="isDSECFunded">
          <v-radio-group
            v-model="editObject.dsec_funded_only"
            mandatory
            :rules="rules.bool"
          >
            <template v-slot:label>
              <div>Is DSEC funding the only funding for the event?*</div>
            </template>
            <v-radio :value="true">
              <template v-slot:label>
                <div>Yes</div>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template v-slot:label>
                <div>No</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12 class="mt-4">
          <v-radio-group
            v-model="editObject.open_to_attendees"
            mandatory
            :rules="rules.bool"
          >
            <template v-slot:label>
              <div>
                Is the event/activity open to attendees from other
                organizations?*
              </div>
            </template>
            <v-radio :value="true">
              <template v-slot:label>
                <div>Yes</div>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template v-slot:label>
                <div>No</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Contact Name*"
            v-model="editObject.contact"
            required
            :rules="rules.required"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            label="Contact Email Address*"
            v-model="editObject.contact_info"
            required
            :rules="rules.email"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-select
            label="By what method is this event/activity conducted?*"
            v-model="editObject.method"
            :items="methods"
            item-text="name"
            item-value="id"
            required
            :rules="rules.required"
          ></v-select>
        </v-flex>
        <v-flex xs12 v-if="editObject.method && !isVirtual">
          <v-text-field label="Venue" v-model="editObject.venue"></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="editObject.method && !isVirtual">
          <v-text-field
            label="Street*"
            v-model="editObject.street"
            :rules="rules.requiredIfNotVirtual"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="editObject.method && !isVirtual">
          <v-text-field
            label="City*"
            v-model="editObject.city"
            :rules="rules.requiredIfNotVirtual"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 v-if="editObject.method && !isVirtual">
          <v-text-field
            label="State*"
            v-model="editObject.state"
            :rules="rules.requiredIfNotVirtual"
          ></v-text-field>
        </v-flex>
        <v-flex xs12>
          <v-menu
            v-model="menus.start_date"
            :close-on-content-click="false"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dates.picker.start_date"
                :rules="rules.required"
                label="Start Date*"
                hint="MM/DD/YYYY format"
                persistent-hint
                prepend-icon="event"
                v-on="on"
                @blur="setStartDate(dateDB(dates.picker.start_date), 'blur')"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates.user.start_date"
              no-title
              :max="editObject.end_date"
              :allowed-dates="allowedDates"
              @input="setStartDate(dates.user.start_date, 'input')"
            ></v-date-picker>
          </v-menu>
        </v-flex>

        <v-layout>
          <v-flex>
            <v-text-field
              label="Start time"
              type="time"
              required
              v-model="editObject.start_time"
              prepend-icon="access_time"
            >
            </v-text-field>
          </v-flex>
        </v-layout>
        <v-flex xs12>
          <v-menu
            v-model="menus.end_date"
            :close-on-content-click="true"
            :nudge-right="40"
            lazy
            transition="scale-transition"
            offset-y
            full-width
            max-width="290px"
            min-width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="dates.picker.end_date"
                :rules="rules.required"
                label="End Date*"
                hint="MM/DD/YYYY format"
                persistent-hint
                prepend-icon="event"
                v-on="on"
                @blur="setEndDate(dateDB(dates.picker.end_date))"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dates.user.end_date"
              no-title
              :min="editObject.start_date"
              @input="setEndDate(dates.user.end_date)"
              :allowed-dates="allowedDates"
            ></v-date-picker>
          </v-menu>
        </v-flex>
        <v-flex xs12>
          <v-text-field
            v-model="editObject.end_time"
            label="End time*"
            type="time"
            required
            prepend-icon="access_time"
          >
          </v-text-field>
        </v-flex>

        <v-flex>
          <v-select
            label="Timezone"
            v-model="editObject.tz"
            :items="tz"
            item-text="name"
            item-value="id"
            required
          ></v-select>
        </v-flex>
        <v-flex>
          <v-text-field
            label="Other Timezone"
            v-model="editObject.tz_other"
            required
            v-if="editObject.tz === 'Other'"
          ></v-text-field>
        </v-flex>

        <v-flex
          v-if="!isPartner || $auth.check('uber_admin')"
          xs12
          class="mt-4"
        >
          <v-textarea
            label="General Timeline (if dates are not known)"
            v-model="editObject.general_date"
            rows="3"
          >
            <template v-slot:append-outer>
              <v-tooltip left max-width="250">
                <template v-slot:activator="{ on }">
                  <i
                    v-bind="attrs"
                    v-on="on"
                    class="fa fa-question-circle"
                    aria-hidden="true"
                  ></i>
                </template>
                <p class="descrpop">
                  If you don't know the exact dates for your event, please
                  provide a general timeline. For example, you might add "Early
                  May 2022."
                </p>
              </v-tooltip>
            </template>
            <template v-slot:label>
              General Timeline (if dates are not known)
            </template>
          </v-textarea>
        </v-flex>
        <v-flex xs12 class="mt-4">
          <v-radio-group v-model="editObject.past_event">
            <template v-slot:append>
              <v-tooltip left max-width="250">
                <template v-slot:activator="{ on }">
                  <i
                    v-bind="attrs"
                    v-on="on"
                    class="fa fa-question-circle"
                    aria-hidden="true"
                  ></i>
                </template>
                <p class="descrpop">
                  If this event is using a general timeline, you can indicate
                  that the event has past by selecting "Yes".
                </p>
              </v-tooltip>
            </template>

            <template v-slot:label>
              <div>Is this a past event that has already taken place?</div>
            </template>

            <v-radio :value="true">
              <template v-slot:label>
                <div>Yes</div>
              </template>
            </v-radio>
            <v-radio :value="false">
              <template v-slot:label>
                <div>No</div>
              </template>
            </v-radio>
          </v-radio-group>
        </v-flex>
        <v-flex>
          <div class="v-messages theme--light mb-4">
            * Indicates that the information is required.
          </div>
        </v-flex>

        <v-flex>
          <div v-if="hasErrors" class="v-messages theme--light error--text">
            <div class="v-messages__wrapper">
              <div class="v-messages__message">
                There were issues trying to save this event. If this continues
                please submit feedback to the Amaze administrator.
              </div>
            </div>
          </div>

          <v-btn
            color="primary"
            class="mx-0 my-4"
            @click="save()"
            :disabled="disabled || !valid"
            v-if="!submitting"
            >Save</v-btn
          >
          <v-progress-circular v-else indeterminate />
        </v-flex>
      </v-form>
      <div v-else>
        <h3>Thank you</h3>
        <div v-if="surveyLink">
          <p>
            For DSEC-funded events, please complete the
            <strong>required</strong> DSEC Event Planning Form to provide
            details. You can also request support from DSEC Elements and STEM
            education partners or for representatives from DoD to attend your
            event.
          </p>
          <v-btn :href="surveyLink" target="_blank" class="ml-0" color="primary"
            >Access Form</v-btn
          >
        </div>
        <div v-else>
          <p>You may now close this screen.</p>
        </div>
      </div>
    </v-layout>
  </v-container>
</template>

<style lang="scss" scoped>
@import "src/styles/variables.scss";
@import "src/styles/dsec-labels.scss";

::v-deep .v-textarea textarea {
  font-size: 16px !important;
}
</style>

<script>
import { EventBus } from "@/components/Events/event-bus.js";
import DSECMixin from "./DSECMixin";
import permissionsMixin from "@/mixins/permissionsMixin.js";
export default {
  mixins: [DSECMixin, permissionsMixin],
  props: {
    item: {
      type: Object
    }
  },
  data() {
    return {
      editObject: {},
      partners: [],
      programs: [],
      methods: [
        {
          id: "I",
          name: "In-Person"
        },
        {
          id: "V",
          name: "Virtual"
        },
        {
          id: "H",
          name: "Hybrid"
        }
      ],
      tz: [
        {
          id: "ET",
          name: "Eastern"
        },
        {
          id: "CT",
          name: "Central"
        },
        {
          id: "MT",
          name: "Mountain"
        },
        {
          id: "PT",
          name: "Pacific"
        },
        {
          id: "Other",
          name: "Other"
        }
      ],
      valid: false,
      disabled: false,
      hasErrors: false,
      submitting: false,
      dates: {
        user: {
          start_date: "",
          end_date: ""
        },
        picker: {
          start_date: "",
          end_date: ""
        }
      },
      menus: {
        start_date: false,
        end_date: false
      },
      rules: {
        end_date: [true],
        required: [(v) => !!v || "This field is required."],
        bool: [(v) => v === true || v === false || "This field is required"],
        requiredIfNotVirtual: [(v) => !!v || "This field is required."],
        description: [
          (v) => !!v || "The description is required.",
          (v) =>
            (v || "").length <= 200 ||
            "The description should be less than 200 characters."
        ],
        email: [(v) => /@/.test(v) || "Please enter a valid email."]
      },
      eventCreated: false,
      surveyLink: null
    };
  },
  watch: {
    isDSECFunded: {
      handler(val) {
        if (val === false) {
          this.editObject.dsec_funded_only = false;
        }
      },
      deep: true
    }
  },
  computed: {
    isVirtual: function () {
      return this.editObject.method === "V";
    },
    isDSECFunded() {
      return this.editObject.dsec_funded;
    },
    filteredPrograms() {
      return this.programs
        ? this.programs.filter(
          (program) =>
            program.dsec_partner_id === this.editObject.dsec_partner_id
        )
        : [];
    }
  },
  methods: {
    getPrograms: _.debounce(async function () {
      this.loading = true;
      let programs = await this.$http.get("dsec/program");
      this.programs = programs.body;
      this.loading = false;
    }, 500),
    allowedDates(val) {
      const startDateString = process.env.VUE_APP_OPERATING_YEAR_START_DATE
        ? process.env.VUE_APP_OPERATING_YEAR_START_DATE
        : false;
      const endDateString = process.env.VUE_APP_OPERATING_YEAR_END_DATE
        ? process.env.VUE_APP_OPERATING_YEAR_END_DATE
        : false;
      const startDate = startDateString ? new Date(startDateString) : false;
      const endDate = endDateString ? new Date(endDateString) : false;
      const thisDate = new Date(val);

      // Basically if no start/end date for DSEC OY is set, then we allow all dates.
      // Also let uber admins do the thing that others cannot do.
      if (!startDate || !endDate || this.$auth.check("uber_admin")) {
        return true;
      }

      return thisDate >= startDate && thisDate <= endDate;
    },
    standardizeDate(dt) {
      // The format(s) are inconsistent (sometimes with HH:MM:SS others without)
      // which makes date comparison finicky. This helps address that.
      // Expects YYYY-MM-DD or YY-MM-DD HH:MM:SS format.
      return this.dateDB(this.dateUser(dt));
    },
    endDateValidationMessage() {
      return ["The end date cannot occur before the start date."];
    },
    setEndDate(dt, evtString) {
      // First check to make sure that end date occurs before start date.
      if (
        this.editObject.start_date &&
        this.standardizeDate(dt) <
          this.standardizeDate(this.editObject.start_date)
      ) {
        this.rules.end_date = this.endDateValidationMessage();
      } else {
        this.rules.end_date = [true];
      }

      this.editObject.end_date = dt;
      this.dates.user.end_date = dt;
      this.dates.picker.end_date = this.dateUser(dt);
    },
    setStartDate(dt, evtString) {
      // First check to make sure that end date occurs before start date.
      if (
        this.editObject.end_date &&
        this.standardizeDate(dt) >
          this.standardizeDate(this.editObject.end_date)
      ) {
        this.rules.end_date = this.endDateValidationMessage();
      } else {
        this.rules.end_date = [true];
      }

      this.editObject.start_date = dt;
      this.dates.user.start_date = dt;
      this.dates.picker.start_date = this.dateUser(dt);

      if (!this.editObject.end_date) {
        // If end date is not already set, then let's give it the same date
        // as the start date by default.
        this.setEndDate(dt);
      }
    },
    // setEndTime() {
    //   console.log("hi");
    //   if (!this.editObject.end_time) {
    //     this.editObject.end_time = this.editObject.start_time;
    //   }
    // },
    async save() {
      this.submitting = true;
      this.hasErrors = false;

      if (this.$refs.eventForm.validate()) {
        this.disabled = true;

        if (this.editObject.id) {
          await this.$http
            .put("dsec/events/" + this.editObject.id, this.editObject)
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.hasErrors = true;
            });

          if (!this.hasErrors) {
            this.editObject = {};
            EventBus.$emit("refreshEvents");
          }

          this.disabled = false;
          this.$emit("close");
        } else {
          let res = await this.$http
            .post("dsec/events", this.editObject)
            // eslint-disable-next-line handle-callback-err
            .catch((error) => {
              this.hasErrors = true;
            });

          if (!this.hasErrors) {
            this.eventCreated = true;
            // Per Nov 2021 request, if the event isn't DSEC funded then
            // the survey links should be hidden. By making the the
            // survey link false, we can conditionally show/hide the
            // button to access the survey.
            this.surveyLink = this.editObject.dsec_funded
              ? res.body.links["pre-survey"]
              : false;
            this.editObject = {};
            EventBus.$emit("refreshEvents");
          }

          this.disabled = false;
        }
      }

      // Since it's all await anyway.
      this.submitting = false;
    }
  },
  async mounted() {
    // // 2021-11-04: Although not originally noted in comments,
    // // this is here because of a request that we have
    // // DSEC funded be true by default, since most events
    // // are anticipated to be funded by DSEC.
    if (this.item && !this.item.hasOwnProperty("dsec_funded")) {
      this.item.dsec_funded = true;
    }

    this.editObject = JSON.parse(JSON.stringify(this.item));

    if (this.amazeUserCan("administer", "dsec_calendar")) {
      let partners = await this.$http.get("dsec/partners");
      this.partners = partners.body;
    } else {
      this.partners = this.$auth.user().dsec_partners;
      if (this.partners.length === 1) {
        this.editObject.dsec_partner_id = this.partners[0].id;
      }
    }
    if (this.editObject.start_date) {
      this.setStartDate(this.editObject.start_date);
      // this.formatted_start_date = this.dateUser(this.editObject.start_date);
    }
    if (this.editObject.end_date) {
      this.setEndDate(this.editObject.end_date);
      // this.formatted_end_date = this.dateUser(this.editObject.end_date);
    }

    this.getPrograms();
  }
};
</script>
